import styled from "styled-components";
import { device } from "../../styles/devices";

export const FooterContainer = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    padding: 0 20px;
`;
export const FooterContent = styled.footer`
    background-color: var(--color-white);
    padding: 3rem 0;

    @media ${device.tablet}{
        padding: 3rem 0 6rem;
    }

    div {
        text-align: center;
        
        & > a {
            font-size: 1.5rem;
            font-weight: var(--font-bold);
            line-height: 2rem;
            color: var(--color-black);
            transition: .3s;
            margin-bottom: 2rem;
            display: block;

            &:hover{
                color: var(--color-black-hover);
            }
        }

        nav{
            margin-bottom: 2rem;
            ul{
                display: flex;
                align-items: center;
                justify-content: center;
                column-gap: 1.5rem;

                @media ${device.mobileSmall}{
                    flex-direction: column;
                    row-gap: 1.5rem;
                }

                li{
                    a{
                        font-size: 1rem;
                        font-weight: var(--font-medium);
                        color: var(--color-black);
                        transition: .3s;

                        &:hover{
                            color: var(--color-black-hover);
                        }
                    }
                }
            }
        }

        & > ul{
            display: grid;
            grid-template-columns: repeat(3,64px);
            gap: 1rem;
            justify-content: center;
            margin-bottom: 2.5rem;

            li{

                a{
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    background-color: var(--color-black);
                    border-radius: var(--button-radius);
                    padding: 0.8rem;
                    transition: background-color .3s;

                    &:hover{
                        background-color: var(--color-black-hover);
                    }

                    i{
                        font-size: 1.5rem;
                        line-height: 1.5rem;
                        color: var(--color-white);
                    }
                }
            }
        }

        & > p{
            font-size: 1rem;
            font-weight: var(--font-normal);
            line-height: 1.5rem;
            color: var(--color-text)
        }
    }
`;